/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import './styles.css';

class BaseModal extends React.Component {
  constructor(props) {
    super(props);
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onDialogClick = this.onDialogClick.bind(this);
  }

  componentDidMount() {
    if (this.props.onClose) {
      window.addEventListener('keydown', this.listenKeyboard.bind(this), true);
    }
  }

  componentWillUnmount() {
    if (this.props.onClose) {
      window.removeEventListener('keydown', this.listenKeyboard.bind(this), true);
    }
  }

  onOverlayClick() {
    this.props.onClose();
  }

  // eslint-disable-next-line class-methods-use-this
  onDialogClick(event) {
    event.stopPropagation();
  }

  listenKeyboard(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.props.onClose();
    }
  }

  render() {
    const { children } = this.props;
    // const overlayStyle = this.props.overlayStyle ? this.props.overlayStyle : {};
    // const contentStyle = this.props.contentStyle ? this.props.contentStyle : {};
    // const dialogStyle = this.props.dialogStyle ? this.props.dialogStyle : {};
    return (
      <div>
        <div styleName="modal-overlay-div">
          <div styleName="modal-content-div" onClick={this.onOverlayClick}>
            <div styleName="modal-dialog-div" onClick={this.onDialogClick}>
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BaseModal;




// WEBPACK FOOTER //
// ./src/components/BaseModal/index.js